
import React from "react";
import TestimonialCard from "@/components/TestimonialCard";
import { ThumbsUp, Info } from "lucide-react";

const TestimonialsSection = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <span className="inline-flex items-center text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            <ThumbsUp className="h-4 w-4 mr-2" />
            Stimmen zum Coaching
          </span>
          <h2 className="animate-fade-in mb-4" style={{ animationDelay: '100ms' }}>
            Was Klienten über ihre Coaching-Erfahrung sagen
          </h2>
          <p className="text-joerg-600 mb-6">
            Diese Erfahrungsberichte spiegeln wider, wie mein ganzheitlicher Ansatz Menschen dabei unterstützt, 
            ein selbstbestimmtes Verhältnis zu ihren Finanzen zu entwickeln.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <TestimonialCard
            content="Das Coaching hat mein Verhältnis zu Geld grundlegend verändert. Jörg hat mir geholfen, meine Werte und finanziellen Entscheidungen in Einklang zu bringen. Jetzt fühle ich mich selbstbestimmt und sicher."
            author="Claudia M."
            role="Ärztin"
            delay={0}
          />
          
          <TestimonialCard
            content="Durch das strukturierte und dennoch flexible Coaching konnte ich endlich meine finanziellen Blockaden überwinden. Jörg hat mich genau dort abgeholt, wo ich stand – ohne Vorurteile und mit echtem Verständnis."
            author="Thomas K."
            role="Informatiker"
            delay={150}
          />
          
          <TestimonialCard
            content="Das Coaching war für mich wie eine Entdeckungsreise. Ich habe nicht nur praktische Finanzstrategien gelernt, sondern auch verstanden, wie meine Emotionen meine finanziellen Entscheidungen beeinflussen."
            author="Martina W."
            role="Lehrerin"
            delay={300}
          />
        </div>
        
        <div className="mt-8 text-sm text-joerg-500 flex items-center">
          <Info className="h-4 w-4 mr-2 text-joerg-400 flex-shrink-0" />
          <span>Aus Datenschutzgründen wurden Namen pseudonymisiert. Die Berufsbezeichnungen entsprechen den tatsächlichen Tätigkeitsfeldern. Alle Testimonials basieren auf echtem Feedback.</span>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
